import {setDeviceState} from '../../redux/actions';
import {useSelector} from "react-redux";
import {debounce} from "../functions";

export default class DeviceState {

    constructor(dispatch) {
        this.dispatch = dispatch;                      //redux action dispatch function
        this.indicator = document.createElement('div'); //div element to use for measurement
        this.indicator.className = 'state-indicator';             //div class
        this.debounce_delay = 50;                            //debounce delay in milliseconds
        this.firstRender = true;
        document.body.appendChild(this.indicator);
        this.start();
    };

    //returns the current device state according to the width of the screen as measured by
    //the state-indicator div.
    getScreen = () => {
        var index = parseInt(window.getComputedStyle(this.indicator).getPropertyValue('z-index'), 10);
        var states = {
            1: 'desktop-large',
            2: 'desktop',
            3: 'tablet',
            4: 'mobile'
        };
        return states[index] || 'desktop';
    };

    //Debounce the device state function so that it is called only once every 250ms


    start = () => {
        //Listen for screen resize with a debounce
        var response = debounce(() => {

            //determine current device
            let device = this.getScreen();

            //set device type in the redux store
            this.dispatch(setDeviceState(device));

        }, this.debounce_delay, this.firstRender);

        this.firstRender = false;
        window.addEventListener('resize', response);

        response();
    }
}

// TODO: replace DeviceState component with useDeviceState hook completely
export function useDeviceState() {

    const deviceState = useSelector(state => state.state.deviceState)


    return {
        deviceState,
        isMobile: deviceState === 'mobile',
        isTablet: deviceState === 'tablet',
        isDesktop: deviceState === 'desktop',
        isDesktopLarge: deviceState === 'desktop-large',
    }
}
